module.exports = __webpack_public_path__ + "img/usen_camera_logo.9383bf1a.png";